import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { selectMatchingVideoSource } from '../utils';

gsap.registerPlugin(ScrollTrigger);

export default class Media {
	constructor(el) {

        if (!'ResizeObserver' in window) {
			return;
		}

        this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));

        this.togglePlayButton = el.querySelector('[data-toggle-play]');
		this.toggleSoundButton = el.querySelector('[data-toggle-sound]');

        this.autoplayVideos = el.querySelectorAll('[data-autoplay-video]');

		// TODO naamgeving nog veranderen. want suggereert meerdere autoplay video's maar het zijn er maar 2 in de hero waarvan er 1 op autoplay staat.

        this.autoplayVideos.forEach(autoplayVideo => {
            new Video(autoplayVideo);

			this.resizeObserver.observe(autoplayVideo);

            if(autoplayVideo.getBoundingClientRect().height) {
			    autoplayVideo.dispatchEvent(new CustomEvent('play-video'));
            }
        });

        this.breakpoint = window.matchMedia('(min-width:768px)');

        this.breakpoint.addEventListener('change', () => {
            this.autoplayVideos.forEach(autoplayVideo => {
                if(autoplayVideo.getBoundingClientRect().height) {
                    autoplayVideo.dispatchEvent(new CustomEvent('play-video'));
                } else {
                    autoplayVideo.dispatchEvent(new CustomEvent('pause-video'));
                }
            });
        });

		if(this.toggleSoundButton) {
			this.toggleSoundButton.addEventListener('click', () => {
				this.toggleSound();
			});
		}

		if(this.togglePlayButton) {
			this.togglePlayButton.addEventListener('click', () => {
				this.togglePlay();
			});
		}

        // Animate Page title
		const containerElLeft = el.querySelector('[data-text-left]');
		const containerElRight = el.querySelector('[data-text-right]');

        gsap.from([containerElLeft,containerElRight], {
            opacity: 0.3,
            y: 150,
            ease: "power3.out",
            duration: 2
        });
	}

    handleResize(entries) {
		entries.forEach(entry => {
			const target = entry.target;
			target.dispatchEvent(new CustomEvent('select-source'));
		});
	}

	togglePlay() {
        this.autoplayVideos.forEach(video => {
            if(video.getBoundingClientRect().height) {
                video.dispatchEvent(new CustomEvent('toggle-play'));
            }
        });
	}

	toggleSound() {
        this.autoplayVideos.forEach(video => {
            video.dispatchEvent(new CustomEvent('toggle-sound'));
        });
	}
}


class Video {
    constructor(autoplayVideo) {
		this.elm = autoplayVideo;

		this.video = this.elm.querySelector('video');
		if(!this.video) {
			return;
		}

		this.newTime = null;
		this.shouldPlay = false;

		this.elm.addEventListener('select-source', () => {
			this.selectSource();
		});

		this.elm.addEventListener('play-video', () => {

			this.playVideo();
		});

		this.elm.addEventListener('pause-video', () => {
			this.pauseVideo();
		});

        this.elm.addEventListener('toggle-sound', () => {
			this.video.muted ? this.unmuteVideo() : this.muteVideo();
		});

        this.elm.addEventListener('toggle-play', () => {
            this.video.paused ? this.playVideo() : this.pauseVideo();
        });

		this.video.addEventListener('loadedmetadata', () => {
			if(this.newTime) {
				this.video.currentTime = this.newTime;
				this.newTime = null;
			}
		});
    }

	playVideo() {
        this.shouldPlay = true;
		let startPlayPromise = this.video.play();
		if (startPlayPromise !== undefined) {
			startPlayPromise.then(() => {
				this.elm.classList.add('is-playing');
				this.elm.classList.remove('has-error');
			}).catch((error) => {
				if(!this.elm) {
					return;
				}
				this.elm.classList.add('has-error');
			});
		}
	}

	pauseVideo() {
        this.shouldPlay = false;
		this.video.pause();
	}

    muteVideo() {
        this.video.muted = true;
    }

    unmuteVideo() {
        this.video.muted = false;
    }

	selectSource() {
		this.oldTime = this.video.currentTime;
		selectMatchingVideoSource(this.video).then(() => {
			this.newTime = this.oldTime;
			if(this.shouldPlay) {
				this.playVideo();
			}
		});
	}
}
